import React, { useEffect, useState } from "react";
import TitlePages from "../../../layout/TitlePages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { getPOAData } from "../../../data/dataTransparenciaPOA";
import Breadcrumbs from "../../../layout/Breadcrumbs";
import "../Transparencia.css";

const baseURL = "https://itetlax.org.mx/assets/pdf/POA/";

const dataYears = [2018, 2019, 2020, 2023, 2024, 2025];

// Años que tienen estructura por trimestres
const yearsWithTrimesters = [2025];

const Poa = () => {
  const [selectedTrimester, setSelectedTrimester] = useState(null);
  const [activeYear, setActiveYear] = useState(dataYears[0]);

  useEffect(() => {
    document.title = `POA`;
  }, []);

  const handleTrimesterChange = (e) => {
    const value = e.target.value;
    setSelectedTrimester(value !== "" ? value : null);
  };

  return (
    <>
      <div className="margin-bottom-2">
        <Breadcrumbs
          path={[
            { label: "Transparencia", url: "/Transparencia" },
            { label: "POA" },
          ]}
        />
        <TitlePages
          title="Transparencia"
          subTitle="Programas Operativos Anuales (POA)"
        />
        <div className="mt-3 mb-3 d-flex align-items-start w-100">
          <div
            className="nav flex-column nav-pills me-3 w-25"
            id="vPillsContenidoRegistro"
            role="tablist"
            aria-orientation="vertical"
          >
            {dataYears.map((year, index) => (
              <button
                key={year}
                className={`btn btn-ite ${activeYear === year ? "active" : ""}`}
                id={`vPillsPOA${year}Tab`}
                data-bs-toggle="pill"
                data-bs-target={`#vPillsPOA${year}`}
                type="button"
                role="tab"
                aria-controls={`vPillsPOA${year}`}
                aria-selected={activeYear === year ? "true" : "false"}
                onClick={() => {
                  setSelectedTrimester(null);
                  setActiveYear(year);
                }}
              >
                POAS {year}
              </button>
            ))}
          </div>

          <div className="tab-content w-75" id="vPillsPOASContent">
            {dataYears.map((year, index) => {
              const isTrimestral = yearsWithTrimesters.includes(year);
              const data = !isTrimestral ? getPOAData(year) : [];

              return (
                <div
                  key={year}
                  className={`tab-pane fade ${
                    activeYear === year ? "show active" : ""
                  }`}
                  id={`vPillsPOA${year}`}
                  role="tabpanel"
                  aria-labelledby={`vPillsPOA${year}Tab`}
                >
                  <h2 className="text-center mb-3">
                    Programas Operativos Anuales {year}
                  </h2>

                  {isTrimestral ? (
                    <>
                      <div className="d-flex justify-content-center mb-3">
                        <select
                          className="form-select w-50"
                          onChange={handleTrimesterChange}
                          value={selectedTrimester || ""}
                        >
                          <option value="">Selecciona un trimestre</option>
                          <option value="1">1er Trimestre</option>
                          <option value="2">2do Trimestre</option>
                          <option value="3">3er Trimestre</option>
                          <option value="4">4to Trimestre</option>
                        </select>
                      </div>

                      {selectedTrimester && (
                        <div>
                          <h4 className="text-center">
                            Trimestre {selectedTrimester}
                          </h4>
                          <table className="table table-striped table-hover">
                            <thead>
                              <tr>
                                <th></th>
                                <th></th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {getPOAData(`${year}_T${selectedTrimester}`).map(
                                (poa) => (
                                  <tr key={poa.id}>
                                    <th scope="row">{poa.id}</th>
                                    <td>{poa.title}</td>
                                    <td>
                                      <a
                                        className="btn btn-danger btn-sm"
                                        href={`${baseURL}${year}/T${selectedTrimester}/${poa.id}.pdf`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <FontAwesomeIcon icon={faFilePdf} />
                                      </a>
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </>
                  ) : (
                    <table className="table table-striped table-hover mt-3">
                      <thead>
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((poa) => (
                          <tr key={poa.id}>
                            <th scope="row">{poa.id}</th>
                            <td>{poa.title}</td>
                            <td>
                              <a
                                className="btn btn-danger btn-sm"
                                href={`${baseURL}${year}/${poa.id}.pdf`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <FontAwesomeIcon icon={faFilePdf} />
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Poa;
